<template>
  <div style="font-family: -apple-system-font ,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
    <div class="carousel">
      案例精选
    </div>
    <div class="case_main">
      <div class="case_top">
        <div class="case_title">烟台福山环卫大脑智能平台</div>
        <div class="case_time">
          <img
            src="../../assets/images/developerCommunity/dev_time.png"
            alt=""
          />
          <span>2020/06/12</span>
        </div>
        <hr />
      </div>
      <div class="case_detail">
        <!-- <div class="model">
          <div class="model_title">【企业介绍】</div>
          <div class="section">
          </div>
        </div> -->
        <div class="model">
          <div class="model_title">【项目概况】</div>

          <div>
            <div class="section">
              通过“环卫大脑”实现机械保洁，餐厨收运，垃圾收运线路自动规划，环卫事件自动派发，作业数据自动统计的智能化环卫运营“福山模式”。智慧环卫大脑是基于太的科技自主开发的Tide Cloud大数据平台研发的TideBrain 1.0系统，是城市环卫管理的核心载体。以总部监管中控IOC平台为依托，采用“物联网+智能数据中台+智能终端”三位一体系统架构，在运营方面实现环卫管理中人、车、物、事的可视化、智能化，通过精细化运营，为政府决策和部门业务提供科学、精准、全方位的数据与人工智能视觉分析能力支撑.
            </div>
          </div>
        </div>
        <div class="model">
          <div class="model_title">【项目效果】</div>
          <div class="section">
            <img src="../../assets/taidi/1.png" alt="" />
          </div>
          <div class="section">
            助力客户智能化运营，项目高效运转，打造环卫运营智能模式。自动实现所有车辆作业的最优完成路径，并将结果传输至各车辆的智能终端，提升作业效率的同时，降低运营成本。通过移动智能终端可简易上报突发信息，IOC监控中心可以及时接收到通知，并快速调度附近作业单位处理。对环卫作业实现深度的监测及自动考核，并且车联网风控系统将通过设备实时检测运行，了解装备运行位置/状态、实时掌握车辆驾驶员驾驶行为、实时获取装备故障报警掌握装备健康状况，充分有效降低人力运营成本及管理成本。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CaseTadidiDetail",
  data() {
    return {
      detailId: this.$route.params.id
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.init();
  },
  methods: {
    init() {
      console.log(this.detailId);
    }
  }
};
</script>

<style lang="scss">
.carousel {
  background-color: #1a1a1a;
  height: 4rem;
  text-align: center;
  line-height: 4rem;
  font-size: 0.4rem;
  color: #ffffff;
}

.case_main {
  padding: 0 2.4rem;
  margin-bottom: 0.3rem;

  .case_top {
    margin-top: 0.6rem;

    .case_title {
      font-size: 0.32rem;
    }

    .case_time {
      margin-top: 0.2rem;
      font-size: 0.18rem;
      color: #999999;
      display: flex;
      align-items: center;
      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.1rem;
      }
    }

    hr {
      margin-top: 0.4rem;
      color: #cccccc;
    }
  }

  .case_detail {
    margin: 0 2.2rem;
    margin-bottom: 0.6rem;
    color: #000000;
    img {
      width: 100%;
    }
    .model {
      margin-top: 0.2rem;
      .model_title {
        font-size: 0.22rem;
        font-weight: 600;
      }
      .imageContainer {
        width: 100%;
        display: flex;
        justify-content: space-around;
        img {
          width: 242px;
        }
      }
      .section {
        padding-left: 0.12rem;
        text-indent: 2em;
        line-height: 0.36rem;
        font-size: 0.18rem;
        margin-top: 0.12rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail_page/CaseTaidiDetail.vue